import React from "react";
import { usStates } from "../../constants/usStates";

const canadianProvinces = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NS", label: "Nova Scotia" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NU", label: "Nunavut" },
  { value: "YT", label: "Yukon" },
];

/**
 * StateSelector - A country-aware region selector
 * Shows US states by default, Canadian provinces when country is "Canada"
 * @param {string} value - The selected state/province value
 * @param {function} onChange - Callback when selection changes
 * @param {string} country - "Canada" or "United States" (defaults to US)
 * @param {string} className - Optional custom className
 * @param {boolean} disabled - Whether the select is disabled
 * @param {string} name - Optional name attribute for form integration
 * @param {string} id - Optional id attribute
 */
function ProvinceSelector({
  value,
  onChange,
  country,
  className = "block w-full rounded-sm border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
  disabled = false,
  name,
  id
}) {
  const isCanada = country === "Canada";
  const regions = isCanada ? canadianProvinces : usStates;
  const placeholder = isCanada ? "Select Province" : "Select State";

  return (
    <select
      value={value || ""}
      onChange={onChange}
      disabled={disabled}
      name={name}
      id={id}
      className={className}
    >
      <option value="">{placeholder}</option>
      {regions.map((region) => (
        <option key={region.value} value={region.value}>
          {region.label}
        </option>
      ))}
    </select>
  );
}

// Export the state lists for use elsewhere
export { canadianProvinces, usStates };

export default ProvinceSelector;
